<template>
  <div id="app">
    <div id="formulaBox" style="display: none;"></div>
    <custom-header :class="{'show-head': showHeader}" @login="login" ref="customHeader"></custom-header>
    <router-view ref="main" @initProject="initProject" @openFeedback="feedback" @openExpApply="expApply"></router-view>
  </div>
</template>

<script>
import customHeader from "@/components/customHeader.vue";
import {isCnkiEnv} from "@/utils/tools";
import {mapState} from "vuex";

export default {
  name: 'App',
  components: {
    customHeader
  },
  data() {
    return {
      showHeader: false,
    }
  },
  computed: {
    ...mapState(["userExp"]),
  },
  watch: {
    $route(to, from) {
      if (from.path === '/home') { // !important编辑器实例销毁火狐的bug
        tinymce.activeEditor.destroy();
      }
      if (to.path === '/fileManager') {
        this.$refs.customHeader.setExp();
      }
      this.showHeader = !['/login','/login_new','/retail', '/legalhistory', '/legalpublicity'].includes(to.path.toLowerCase());
      if (this.isEmbed) {
        this.showHeader = false;
      }
    }
  },
  methods: {
    feedback() {
      this.$refs.customHeader.feedbackDiaVis = true;
    },
    expApply() {
      this.$refs.customHeader.expDiaVis = true;
    },
    login() {
      this.$refs.main.goLogin();
    },
    initProject() {
      this.init(true);
    },
    init(confirmInfo) {
      this.$store.dispatch('getSections');
      this.$store.dispatch('getUserInfo');
      this.$store.dispatch('getUserInfoExtra', confirmInfo).then((res) => {
        if (res === true) { // 信息完善
          this.$router.push({
            path: '/fileManager'
          });
        }  else if (res === false) { // 信息不完善
          // this.$refs.customHeader.dialogVisible = true; // 新增判断是否体验申请通过，如果通过了才弹窗
          this.popup();
        }
      })
    },
    popup() {
      new Promise((resolve, reject) => {
        let itv = setInterval(() => {
          if (this.userExp !== '') {
            clearInterval(itv);
            resolve();
          }
        }, 100)
      }).then(() => {
        if (this.userExp && this.userExp.status === 2) {
          this.$refs.customHeader.dialogVisible = true;
        } else {
          this.$router.push({
            path: '/fileManager'
          });
        }
      })
    },
    changeHttps() {
      if (isCnkiEnv() && location.protocol === 'http:') {
        window.open(location.href.replace('http', 'https'), '_self');
      }
    }
  },
  created() {
    this.changeHttps();
    this.init();
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}
</style>
<style scoped>
.show-head {
  height: 50px;
}
</style>
